module.exports = __webpack_public_path__ + "static/media/karuna.590625d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/prelogin/public/img/testimonial/karuna.png
// module id = 1282
// module chunks = 0